import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Checkbox from './Checkbox';
import StarRating from './StarRating';
import { FilterValueProps } from '../models/components/Filter';
import Translate from './Translate';

const FilterListItem = styled<any, any>('li')`
    ${propStyles};
`;

const FilterValueLabel = styled<any, any>('div')`
    ${propStyles};
`;

const checkboxStyleProps = {
    height: '1.4em',
    width: '1.4em',
    marginX: 'xs',
};

const starIconStyleProps = {
    height: '1.4em',
    width: '1.4em',
};

const FilterValue: React.SFC<FilterValueProps> = ({
    theme,
    label,
    checked,
    onChange,
    active,
    ui,
    value,
    ...props
}) => {
    return (
        <FilterListItem {...props}>
            {ui === 'dropdown' && (
                <FilterValueLabel
                    data-selected={checked}
                    onClick={onChange}
                    {...theme.FilterDropdownItemValue}
                >
                    <Translate>{label}</Translate>
                </FilterValueLabel>
            )}
            {ui !== 'dropdown' && (
                <Checkbox
                    checked={checked}
                    active={active}
                    onChange={onChange}
                    theme={{
                        ...theme,
                        CheckboxChecked: {
                            ...checkboxStyleProps,
                        },
                        CheckboxUnchecked: {
                            ...checkboxStyleProps,
                        },
                    }}
                >
                    {ui === 'stars' ? (
                        <StarRating
                            rating={value}
                            theme={{
                                ...theme,
                                // If not cast as any there is a TS error
                                // [ts] Spread types may only be created from object types. [2698]
                                // Seems to be a bug in project version of TS
                                ...(theme.StarRatingFilterWrapper as any),
                                StarIcon: {
                                    ...starIconStyleProps,
                                    ...(theme.StarIconFilter as any),
                                },
                                StarOutlineIcon: {
                                    ...starIconStyleProps,
                                    ...(theme.StarOutlineIconFilter as any),
                                },
                            }}
                        />
                    ) : (
                        <FilterValueLabel
                            data-selected={checked}
                            {...theme.FilterItemValue}
                        >
                            <Translate>{label}</Translate>
                        </FilterValueLabel>
                    )}
                </Checkbox>
            )}
        </FilterListItem>
    );
};

export default withTheme(observer(FilterValue));



// WEBPACK FOOTER //
// ./src/Components/FilterValue.tsx